export default __webpack_public_path__ + "static/media/logo_en.3fa676dd.png";